


































































































































































































































































































































































import { mapActions, mapGetters, mapMutations } from 'vuex';
import LocationSelects from '@/components/.global/LocationSelects.vue';
import { Actor, IActor } from '@types';
import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import RatingBanner from '@/components/Profile/Ratings/RatingBanner.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import MyVoice from '@/components/Actors/MyVoice.vue';
import { EnumsApi } from '@/api';

export default {
    name: 'ActorsDetails',

    components: {
        MyVoice,
        Mp3Player,
        RatingBanner,
        PageHeader,
        LocationSelects,
    },

    data: () => ({
        state: 'idle',
        formData: <Actor.ProfileFormData>{
            personalData: {
                telefon: '',
                telefon2: '',
            },
            locations: [],
            properties: {},
            status: 1,
            pohlavie: 'm',
        },
        phonesDirty: false,
        phonesValid: false,
        locationsDirty: false,
        languages: [{}],
        bible: [{}],
        showStatus: false,
        err: [{}],
    }),

    async mounted() {
        if (this.$route.params.id) {
            await this.loadActorProfile(this.$route.params.id);
            this.formData = this.getActorProfile;
        }

        await this.loadBible();
        await this.loadLangs();
    },

    methods: {
        ...mapMutations({}),

        ...mapActions(['loadActorProfile', 'saveActorProfile']),

        async loadBible() {
            const { data } = await EnumsApi.loadBible();
            this.bible = data.records;
        },

        async loadLangs() {
            const { data } = await EnumsApi.loadLangs();
            this.languages = data.records;
        },

        back() {
            this.$router.push({ path: '/actors' }).catch(() => {});
        },

        onPhoneInput(response: any) {
            this.phonesDirty = response.isDirty;
            this.phonesValid = response.isValid;
        },

        onLocationsUpdate(value: any) {
            if (value === null || value?.type?.slug == 'county') {
                this.locationsDirty = true;
            }
        },

        async save() {
            this.saveActorProfile(this.formData as IActor)
                .then((response: any) => {
                    this.formData = response;
                    this.err = [];

                    this.showStatus = true;
                })
                .catch((error: any) => {
                    this.err = error.response.data.data;
                });
        },
    },

    computed: {
        ...mapGetters(['getActorProfile', 'getSampleMp3Url']),

        locationValid() {
            return !this.location || this.location.type.slug == 'county';
        },

        isDirty(): boolean {
            return (
                Object.values(this.fields).some((field: any) => field.dirty) || this.phonesDirty || this.locationsDirty
            );
        },

        isValid(): boolean {
            return (
                Object.values(this.fields).every((field: any) => field.valid) && this.phonesValid && this.locationValid
            );
        },

        isSubmittable() {
            return this.isValid && this.isDirty;
        },

        location: {
            get() {
                return this.formData.locations[0] || null;
            },
            set(val: any) {
                this.formData.locations = val ? [val] : [];
            },
        },
    },
};
